import { API_HOST, getHttpPostOptions, getHttpGetOptions, getHttpDeleteOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/reaction`;
const getspecificReactionEndpoint = (memberExternalReference) => `${getEndpoint()}/${memberExternalReference}`;

export const getCreateReactionRequest = (reaction) => [getEndpoint(), getHttpPostOptions(reaction)];

export const getViewReactionsRequest = (memberExternalReference) => [
  getspecificReactionEndpoint(memberExternalReference),
  getHttpGetOptions()
];

export const getDeleteReactionRequest = (reaction, memberExternalReference, postExternalReference) => [
  `${getEndpoint()}/${reaction}/${memberExternalReference}/${postExternalReference}`,
  getHttpDeleteOptions()
];
